import React from "react";

const Platformtoolheader = () => {
  return (
    <div>
      <section>
        <div
          className="relative overflow-hidden bg-no-repeat bg-cover"
          style={{
            backgroundPosition: "50% 50%",
            backgroundImage:
              "url('https://images.unsplash.com/photo-1615992174118-9b8e9be025e7?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80')",
            height: "600px",
          }}
        >
          <div
            className="absolute top-0 right-0 bottom-0 left-0 w-full h-full overflow-hidden bg-fixed"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.75)" }}
          >
            <div className="h-full flex justify-center">
              <div className="flex flex-col justify-center items-center text-white text-center px-6 md:px-12">
                <span
                  className="text-5xl md:text-6xl xl:text-7xl font-bold tracking-tight pb-4 text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-500"
                    data-aos="fade-up"
                    data-aos-duration="1000"
                >
                  Advanced trading tools
                </span>
                <span
                  className="text-2xl font-normal pb-4 text-gray-200"
                    data-aos="fade-up"
                    data-aos-delay="300"
                    data-aos-duration="1300"
                >
                  Gain deeper investment insights and <br className="sm:block hidden" />
                  make your move in the market.
                </span>
                <span
                  className="text-2xl font-normal text-yellow-400 hidden sm:block"
                    data-aos="fade-up"
                    data-aos-delay="500"
                    data-aos-duration="1300"
                >
                  In order to help traders make decisions and develop
                  strategies, GLOBALFX offers a variety of tools. These tools,
                  together with deeper information,
                  <br />
                  allow traders to confidently open and close trades.
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Platformtoolheader;
